import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import { ConfirmModal } from "ceco-modal";
import graphql from "babel-plugin-relay/macro";
import { toast } from "react-toastify";
import { commitMutation } from "react-relay";
import environment from "../../../environment";
import { useTranslation } from "ceco-polyglot";

export default function StepRecipeDeleteModal(props) {
  const { trigger, step, refetchData, isDragging, recipeName } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState();
  const [loading, setLoading] = useState(false);

  const t = useTranslation();
  function deleteStepToRecipe() {
    return new Promise((resolve, reject) => {
      const variables = {
        ...formData,
      };
      commitMutation(environment, {
        mutation: stepRecipeModal_delete_Mutation,
        variables,
        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
      });
    });
  }

  const onSubmit = async () => {
    isDragging.current = false;
    setLoading(true);
    deleteStepToRecipe()
      .then((a) => {
        toast.success(t("message.deleted_step"));
        setModalOpen(false);
        setLoading(false);
        refetchData();
      })
      .catch((e) => {
        if (Array.isArray(e)) {
          toast.error(e[0].message);
        } else {
          toast.error(e.errors[0].message);
        }
      });
  };
  return (
    <ConfirmModal
      modalOpen={modalOpen}
      title={t("modalTitle.removeStep")}
      trigger={React.cloneElement(trigger, {
        onClick: (e) => {
          e.preventDefault();
          setModalOpen(true);

          setFormData({ id: step.id });
        },
      })}
      onClose={() => setModalOpen(false)}
      showCloseButton={true}
      description={
        <div>
          {t("warning.step_remove", {
            stepName: step.description,
            recipeName: recipeName,
          })}
        </div>
      }
      renderActions={() => (
        <div>
          <Button
            disabled={loading}
            color="red"
            onClick={() => {
              onSubmit();
            }}
          >
            {t("action.delete")}
          </Button>
          <Button
            color="green"
            onClick={() => {
              setModalOpen(false);
            }}
          >
            {t("action.cancel")}
          </Button>
        </div>
      )}
    />
  );
}
const stepRecipeModal_delete_Mutation = graphql`
  mutation StepRecipeDeleteModalMutation($id: ID!) {
    recipeStepDelete(input: { id: $id }) {
      deleted
    }
  }
`;
